import { Danger, Home2, Logout, Menu, Setting, Sms } from "iconsax-react";
import {
	MDBBtn,
	MDBCard,
	MDBCardBody,
	MDBCardImage,
	MDBCardText,
	MDBCardTitle,
	MDBCol,
	MDBContainer,
	MDBIcon,
	MDBRow,
} from "mdb-react-ui-kit";
import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import logoutIcon from "../../assets/images/Icon feather-log-out.png";
import logoRah from "../../assets/images/logo-rah.png";
import image from "../../assets/images/Nature-logo-vector-2 2.png";
// ✅ IMPORT USEMATRIX
import { useMatrix } from "../../context/MatrixContext";
import { userLogout } from "../../Store/UserAction";
import { JWTContext } from "../../utils/context/JWTContext";

function UserProfile({ closeUserProfile }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userData = useSelector((state) => state.user.data);
	const { setJWT } = useContext(JWTContext);
	const [isSidebarVisible, setIsSidebarVisible] = useState(true);
	const location = useLocation();

	// ✅ GET LOGOUT FUNCTION FROM CONTEXT
	const { logoutMatrix } = useMatrix();

	const toggleSidebar = () => {
		setIsSidebarVisible(!isSidebarVisible);
	};

	const handleNavigation = (path) => {
		navigate(path);
		if (closeUserProfile) {
			closeUserProfile();
		}
	};

	const handleVerifyMobile = () => {
		const userId = userData?.user.uid;
		navigate(`/verify-mobile/${userId}`);
	};

	// ✅ NEW COMPLETE LOGOUT HANDLER
	const handleLogout = async () => {
		try {
			// 1. Stop Matrix Client (Stop syncing)
			logoutMatrix();

			// 2. Clear Local Storage (Frontend Session)
			// You must manually remove keys because the backend cannot access localStorage
			localStorage.removeItem("token"); // App JWT
			localStorage.removeItem("matrix_config"); // Matrix Creds
			localStorage.removeItem("chatbotMessages"); // Chat history

			// 3. Call Backend (Redux Action)
			await dispatch(userLogout());
		} catch (error) {
			console.error("Logout Error:", error);
		} finally {
			// 4. HARD REDIRECT
			// Force a browser refresh to wipe all React memory/state
			window.location.href = "/login";
		}
	};

	const isActive = (path) => location.pathname.endsWith(path);

	// MOBILE HEADER (top)
	const MobileHeader = () => (
		<div className="user-profile-mobile-header mobile-only simple-header">
			<div className="header-content">
				<div className="header-logo-container">
					<img
						src={logoRah}
						alt="profile"
						className="header-logo"
						onClick={() => handleNavigation("/home")}
						style={{ cursor: "pointer" }}
					/>
				</div>
				{/* ✅ USE NEW HANDLER */}
				<div className="header-logout" onClick={handleLogout}>
					<img src={logoutIcon} alt="logout" className="header-logout-icon" />
					<span className="header-logout-text">خروج</span>
				</div>
			</div>
		</div>
	);

	// MOBILE TAB BAR (bottom)
	const MobileTabBar = () => (
		<div className="user-profile-mobile-tabbar mobile-only">
			<div
				className={`tabbar-item ${isActive("/mbti-form") ? "active" : ""}`}
				onClick={() => handleNavigation("/mbti-form")}
			>
				<Menu size="24" color="currentColor" variant="Linear" />
				<span className="tabbar-label">تست شخصیت MBTI</span>
			</div>
			<div
				className={`tabbar-item ${isActive("/messages") ? "active" : ""}`}
				onClick={() => handleNavigation("/messages")}
			>
				<Sms size="24" color="currentColor" variant="Linear" />
				<span className="tabbar-label">پیام ها</span>
			</div>
			<div
				className={`tabbar-item ${isActive("/home") ? "active" : ""}`}
				onClick={() => handleNavigation("/home")}
			>
				<Home2 size="24" color="currentColor" variant="Linear" />
				<span className="tabbar-label">خانه</span>
			</div>
			<div
				className={`tabbar-item ${isActive("/userProfile") ? "active" : ""}`}
				onClick={() => handleNavigation("/userProfile")}
			>
				<Setting size="24" color="currentColor" variant="Linear" />
				<span className="tabbar-label">حساب کاربری</span>
				{(!userData?.user?.mobile || userData?.user?.mobile === "") && (
					<span className="badge badge-warning">!</span>
				)}
			</div>
		</div>
	);

	// DESKTOP SIDEBAR
	return (
		<>
			<div className="sidebar-container desktop-only">
				<div className="profile-section">
					<img
						src={logoRah}
						alt="User"
						className="profile-img"
						onClick={() => handleNavigation("/home")}
						style={{ cursor: "pointer" }}
					/>
					{!userData?.user.mobile && (
						<div className="mobile-verify-box">
							<div className="mobile-verify-content">
								<span>لطفاً شماره موبایل خود را تأیید کنید</span>
							</div>
							<button
								className="mobile-verify-btn"
								onClick={handleVerifyMobile}
							>
								تایید شماره
							</button>
						</div>
					)}
				</div>

				<div className="menu-section mt-4">
					<div
						className={`menu-item ${isActive("/home") ? "active" : ""}`}
						onClick={() => handleNavigation("/home")}
					>
						<Home2 size="24" color="currentColor" variant="Linear" />
						<span>خانه</span>
					</div>
					<div
						className={`menu-item ${isActive("/messages") ? "active" : ""}`}
						onClick={() => handleNavigation("/messages")}
					>
						<Sms size="24" color="currentColor" variant="Linear" />
						<span>پیام ها</span>
					</div>
					<div
						className={`menu-item ${isActive("/userProfile") ? "active" : ""}`}
						onClick={() => handleNavigation("/userProfile")}
					>
						<Setting size="24" color="currentColor" variant="Linear" />
						<span>حساب کاربری</span>
						{(!userData?.user?.mobile || userData?.user?.mobile === "") && (
							<span className="badge badge-warning">!</span>
						)}
					</div>
					<div
						className={`menu-item ${isActive("/mbti-form") ? "active" : ""}`}
						onClick={() => handleNavigation("/mbti-form")}
					>
						<Menu size="24" color="currentColor" variant="Linear" />
						<span>تست شخصیت MBTI</span>
					</div>
				</div>

				{/* ✅ USE NEW HANDLER */}
				<div className="logout-section" onClick={handleLogout}>
					<img src={logoutIcon} alt="logout" />
					<span className="logout-text">خروج</span>
				</div>
			</div>

			<MobileHeader />
			<MobileTabBar />
		</>
	);
}

export default UserProfile;
